<template>
  <router-link
    v-slot="{ href, isActive, navigate }"
    :to="to"
    custom
    active-class="active"
  >
    <li
      class="relative flex items-center h-8 px-2 my-1 font-medium rounded-md transition-colors duration-200 ease-out"
      :class="[
        isActive
          ? 'bg-woot-25 dark:bg-mint/10'
          : 'hover:bg-slate-50 dark:hover:bg-white/[0.05]',
        {
          'text-ellipsis overflow-hidden whitespace-nowrap max-w-full':
            shouldTruncate,
        },
      ]"
      @click="navigate"
    >
      <span
        v-if="isActive"
        aria-hidden="true"
        class="absolute inset-y-0 w-0.5 h-4 my-auto start-0 rounded-e-full bg-accent-mint"
      />
      <a
        :href="href"
        class="inline-flex items-center w-full max-w-full rounded-md outline-none text-start focus-visible:ring-2 focus-visible:ring-accent-mint/70 focus-visible:ring-offset-1 focus-visible:ring-offset-white dark:focus-visible:ring-offset-ink"
      >
        <span
          v-if="icon"
          class="inline-flex items-center justify-center w-4 p-0.5 rounded-sm me-1.5 bg-slate-100 dark:bg-white/[0.08]"
        >
          <fluent-icon
            class="text-xxs"
            :class="
              isActive
                ? 'text-accent-mint'
                : 'text-slate-600 dark:text-slate-300'
            "
            :icon="icon"
            size="12"
          />
        </span>

        <span
          v-if="labelColor"
          class="inline-flex w-3.5 h-3 border rounded-sm me-1.5 bg-slate-100 border-slate-100 dark:border-white/10"
          :style="{ backgroundColor: labelColor }"
        />
        <div
          class="flex items-center justify-between w-full overflow-hidden whitespace-nowrap text-ellipsis"
        >
          <span
            :title="menuTitle"
            class="text-sm"
            :class="[
              isActive
                ? 'text-accent-mint'
                : 'text-slate-700 dark:text-slate-200',
              {
                'text-ellipsis overflow-hidden whitespace-nowrap max-w-full':
                  shouldTruncate,
              },
            ]"
          >
            {{ label }}
          </span>
          <span
            v-if="showChildCount"
            class="px-1 py-0 mx-1 rounded bg-slate-50 dark:bg-white/[0.06] text-xxs font-medium"
            :class="
              isCountZero
                ? `text-slate-500 dark:text-slate-300`
                : `text-slate-700 dark:text-slate-100`
            "
          >
            {{ childItemCount }}
          </span>
        </div>
        <span
          v-if="warningIcon"
          class="inline-flex rounded-sm me-1 text-yellow-600 dark:text-yellow-500"
        >
          <fluent-icon
            v-tooltip.top-end="$t('SIDEBAR.FACEBOOK_REAUTHORIZE')"
            class="text-xxs"
            :icon="warningIcon"
            size="12"
          />
        </span>
      </a>
    </li>
  </router-link>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelColor: {
      type: String,
      default: '',
    },
    shouldTruncate: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    warningIcon: {
      type: String,
      default: '',
    },
    showChildCount: {
      type: Boolean,
      default: false,
    },
    childItemCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    showIcon() {
      return {
        'overflow-hidden whitespace-nowrap text-ellipsis': this.shouldTruncate,
      };
    },
    isCountZero() {
      return this.childItemCount === 0;
    },
    menuTitle() {
      return this.shouldTruncate ? this.label : '';
    },
  },
};
</script>
